<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="商品设置" name="goods">
        <setGoods v-if="activeName === 'goods'"></setGoods>
      </el-tab-pane>
      <el-tab-pane label="门店设置" name="shop">
        <setShop v-if="activeName === 'shop'"></setShop>
      </el-tab-pane>
      <el-tab-pane label="欢迎语设置" name="welcome">
        <setWelcome v-if="activeName === 'welcome'"></setWelcome>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import setGoods from './comps/set-goods'
import setShop from './comps/set-shop'
import setWelcome from './comps/set-welcome'

export default {
  components: {
    setGoods,
    setShop,
    setWelcome
  },
  data() {
    return {
      activeName: 'goods'
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped></style>
